import * as max from '../max-length-validators';
import * as required from '../required-validators';

export default {
  name: 'nameNumber',
  label: 'checkout.address.field.label.houseNameOrNumber.text',
  required: true,
  maxLength: 32,
  validate: [required.houseNumber, max.lengthHouseNumber(32)],
};
